var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.487183,
    y: 0.623932,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4B00A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7271 20.066C30.7271 25.486 26.2904 29.8927 20.8253 29.8927C19.1578 29.8927 17.5051 29.4772 16.0323 28.668L10.5598 30.4103L12.3448 25.1324C11.4119 23.6089 10.9271 21.8484 10.9271 20.0624C10.9271 14.6424 15.3638 10.2393 20.829 10.2393C26.2941 10.2393 30.7308 14.6424 30.7308 20.066H30.7271ZM29.0707 20.066C29.0707 15.5572 25.3685 11.8832 20.8253 11.8832C16.282 11.8832 12.5836 15.5572 12.5836 20.066C12.5836 21.7864 13.1345 23.4667 14.1592 24.8627L13.1234 27.8989L16.3004 26.8966C17.641 27.7713 19.2276 28.2525 20.829 28.2525C25.3722 28.2525 29.0744 24.5784 29.0744 20.0696L29.0707 20.066ZM25.9451 22.6065C25.9709 22.6721 25.9709 22.7487 25.9709 22.8033C25.9709 23.1277 25.8643 23.4922 25.7468 23.7947C25.4456 24.5237 24.2226 24.9939 23.477 24.9939C22.8453 24.9939 21.5451 24.4472 20.9832 24.1847C19.1064 23.3391 17.9385 21.8921 16.8073 20.2373C16.3078 19.5083 15.8633 18.608 15.8744 17.7077V17.602C15.9001 16.7418 16.2159 16.1295 16.8477 15.5427C17.046 15.3604 17.2553 15.2547 17.5308 15.2547C17.6887 15.2547 17.8467 15.2948 18.0156 15.2948C18.3682 15.2948 18.4343 15.4005 18.5665 15.7395C18.6583 15.9618 19.3268 17.7333 19.3268 17.8645C19.3268 18.3602 18.4196 18.9215 18.4196 19.2204C18.4196 19.286 18.4453 19.3516 18.4857 19.4172C18.7759 20.0296 19.3268 20.733 19.8263 21.2032C20.4286 21.7755 21.075 22.1545 21.8096 22.519C21.9014 22.5701 21.9932 22.6101 22.0997 22.6101C22.4927 22.6101 23.1502 21.3454 23.4917 21.3454C23.7158 21.3454 25.8533 22.4534 25.9488 22.6101L25.9451 22.6065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/Whatsapp Icon.b77b93804a6d4b1cf63d9354c789f3ff.svg";
export { ForwardRef as ReactComponent };